"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ScrollCarousel = _interopRequireDefault(require("../ScrollCarousel"));
var _FullscreenGallery = _interopRequireDefault(require("../FullscreenGallery"));
var _userflow = require("../../utils/userflow");
var _excluded = ["preloadFullscreen", "items", "paginationSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ScrollGallery = /*#__PURE__*/function (_PureComponent) {
  function ScrollGallery(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ScrollGallery);
    _this = _callSuper(this, ScrollGallery, [props]);
    _this.state = {
      fullscreenIndex: null
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.carouselRef = /*#__PURE__*/_react["default"].createRef();
    _this.timer = null;
    return _this;
  }
  (0, _inherits2["default"])(ScrollGallery, _PureComponent);
  return (0, _createClass2["default"])(ScrollGallery, [{
    key: "handleOpen",
    value: function handleOpen(_ref) {
      var _this2 = this;
      var index = _ref.index;
      this.setState({
        fullscreenIndex: index
      }, function () {
        _this2.timer = Date.now();
      });
      var onOpen = this.props.onOpen;
      onOpen({
        index: index,
        id: this.getIdFromIndex(index)
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose(index) {
      var _this3 = this;
      this.setState({
        fullscreenIndex: null
      }, function () {
        _this3.timer = null;
      });
      var onClose = this.props.onClose;
      var time = Date.now() - this.timer;
      onClose({
        id: this.getIdFromIndex(index),
        index: index,
        time: time
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var prevIndex = _ref2.prevIndex,
        index = _ref2.index;
      this.carouselRef.current.scrollTo(index);
      var onChange = this.props.onChange;
      var time = Date.now() - this.timer;
      onChange({
        id: this.getIdFromIndex(index),
        prevId: this.getIdFromIndex(prevIndex),
        index: index,
        prevIndex: prevIndex,
        time: time
      });
      this.timer = Date.now();
    }
  }, {
    key: "getIdFromIndex",
    value: function getIdFromIndex(i) {
      var items = this.props.items;
      return (0, _get2["default"])(items[i], ['special', 'id']);
    }
  }, {
    key: "render",
    value: function render() {
      var fullscreenIndex = this.state.fullscreenIndex;
      var _this$props = this.props,
        preloadFullscreen = _this$props.preloadFullscreen,
        items = _this$props.items,
        paginationSize = _this$props.paginationSize,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ScrollCarousel["default"], (0, _extends2["default"])({}, props, {
        ref: this.carouselRef,
        items: items,
        paginationSize: paginationSize,
        onImageClick: this.handleOpen
      })), Number.isInteger(fullscreenIndex) && /*#__PURE__*/_react["default"].createElement(_FullscreenGallery["default"], {
        defaultIndex: fullscreenIndex,
        preload: preloadFullscreen,
        items: items,
        onClose: this.handleClose,
        onChange: this.handleChange
      }));
    }
  }]);
}(_react.PureComponent);
ScrollGallery.propTypes = {
  className: _propTypes["default"].string,
  preloadFullscreen: _propTypes["default"].number,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _userflow.IMAGES_SIZE.SMALL, _propTypes["default"].string), _userflow.IMAGES_SIZE.FULL, _propTypes["default"].string), _userflow.IMAGES_SIZE.BIG, _propTypes["default"].string.isRequired), _userflow.IMAGES_SIZE.BIG_X2, _propTypes["default"].string)).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })),
  paginationSize: _propTypes["default"].number,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func
};
ScrollGallery.defaultProps = {
  className: '',
  preloadFullscreen: 1,
  items: [],
  onOpen: Function.prototype,
  onClose: Function.prototype,
  onChange: Function.prototype
};
var _default = exports["default"] = ScrollGallery;